import { Component, OnInit } from '@angular/core';
import { IndependenceModel } from 'src/app/analytic-report/declaration.model';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from 'src/app/services/master-data.service';

@Component({
  selector: 'app-my-dpdp-declaration',
  templateUrl: './my-dpdp-declaration.component.html',
  styleUrls: ['./my-dpdp-declaration.component.css']
})
export class MyDpdpDeclarationComponent implements OnInit {

  selectedFinancialYear ;
  financialList;
  reportList ;
  dpdpDeclaration : IndependenceModel;

  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.selectedFinancialYear="";
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
  }

  onViewReport(){
  if(this.selectedFinancialYear== undefined || this.selectedFinancialYear=="" || this.selectedFinancialYear==null){
    this.commonMessageService.swalAlertWithoutIcon('',"Please Select Financial Year.")
    return;
  }
    this.masterDataService.getDpdpIndependence(this.selectedFinancialYear.id,localStorage.getItem('id'),1)
        .subscribe((res) => {
          this.dpdpDeclaration = res;
          console.log("clientIndependence",this.dpdpDeclaration);
          if(this.dpdpDeclaration==null){
            this.commonMessageService.swalAlertWithoutIcon('',"No Record Found.");
          }
        });

  }

}
